import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import partner1 from '../assets/partner_1.png';
import partner2 from '../assets/partner_2.png';
import FeedbackIcon from '../assets/footer/Feedback.svg';
import { createToast } from '../hooks/useToast';
import { API_URL } from '../config';

// ────────────────────────────────────────────────
// SVG логотипы для партнёров
// ────────────────────────────────────────────────
const GoogleLogo = ({ height = 40 }) => (
  <svg height={height} viewBox="0 0 272 92" xmlns="http://www.w3.org/2000/svg" aria-label="Google">
    <path fill="#EA4335" d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
    <path fill="#FBBC05" d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
    <path fill="#4285F4" d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z"/>
    <path fill="#34A853" d="M225 3v65h-9.5V3h9.5z"/>
    <path fill="#EA4335" d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z"/>
    <path fill="#4285F4" d="M35.29 41.41V32h31.86c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.77.36 15.65 16.32.19 35.44.19c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.63.09z"/>
  </svg>
);

const LinkedInLogo = ({ height = 40, theme }) => (
  <svg height={height} viewBox="0 0 180 55" xmlns="http://www.w3.org/2000/svg" aria-label="LinkedIn">
    <path fill={theme === 'dark' ? '#ffffff' : '#0A66C2'} d="M26.5 0C12.4 0 1 11.4 1 25.5S12.4 51 26.5 51 52 39.6 52 25.5 40.6 0 26.5 0zM18.9 38.6h-5.5V19.4h5.5v19.2zm-2.7-21.8c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1zm22.7 21.8h-5.5v-9.3c0-2.2 0-5.1-3.1-5.1-3.1 0-3.6 2.4-3.6 4.9v9.4h-5.5V19.4h5.3v2.6h.1c.7-1.4 2.5-2.9 5.2-2.9 5.6 0 6.6 3.7 6.6 8.4v11.1z"/>
    <text x="60" y="38" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="26" fill={theme === 'dark' ? '#ffffff' : '#0A66C2'}>LinkedIn</text>
  </svg>
);

// ────────────────────────────────────────────────
// 1. Данные / переводы
// ────────────────────────────────────────────────
const PARTNERS = {
  en: [
    { name: 'GEM Alpine Business School', image: partner1, url: 'https://www.grenoble-em.com/  ' },
    { name: 'IncubaGEM', image: partner2, url: 'https://www.grenoble-em.com/devenir-entrepreneur  ' },
    { name: 'Google', svgComponent: 'google', url: 'https://www.google.com/  ' },
    { name: 'LinkedIn', svgComponent: 'linkedin', url: 'https://www.linkedin.com/  ' },
  ],
  fr: [
    { name: 'GEM Alpine Business School', image: partner1, url: 'https://www.grenoble-em.com/  ' },
    { name: 'IncubaGEM', image: partner2, url: 'https://www.grenoble-em.com/devenir-entrepreneur  ' },
    { name: 'Google', svgComponent: 'google', url: 'https://www.google.com/  ' },
    { name: 'LinkedIn', svgComponent: 'linkedin', url: 'https://www.linkedin.com/  ' },
  ],
};

const LEGAL_LINKS = {
  en: [
    { text: 'GDPR', path: '/privacy-policy' },
    { text: 'Privacy settings', path: '/privacy-policy' },
  ],
  fr: [
    { text: 'RGPD', path: '/privacy-policy' },
    { text: 'Paramètres de confidentialité', path: '/privacy-policy' },
  ],
};

const COPYRIGHT = {
  en: '© 2025 Network Assistant. All rights reserved.',
  fr: '© 2025 Network Assistant. Tous droits réservés.',
};

const FEEDBACK_FORM = {
  en: {
    title: "Contact Us",
    subtitle: "Have questions or feedback? Leave your email and we'll get back to you.",
    emailLabel: "Email",
    emailPlaceholder: "your.email@example.com",
    messageLabel: "Message",
    messagePlaceholder: "Tell us what you think...",
    submit: "Send Message",
    success: "Thank you! We'll contact you soon.",
    error: "Error sending feedback. Please try again.",
    button: "Feedback",
  },
  fr: {
    title: "Contactez-nous",
    subtitle: "Des questions ou des commentaires ? Laissez votre email et nous vous répondrons.",
    emailLabel: "Email",
    emailPlaceholder: "votre.email@exemple.com",
    messageLabel: "Message",
    messagePlaceholder: "Dites-nous ce que vous pensez...",
    submit: "Envoyer le message",
    success: "Merci ! Nous vous contacterons bientôt.",
    error: "Erreur lors de l'envoi du feedback. Veuillez réessayer.",
    button: "Avis",
  }
};

const SOCIAL_ICONS = ['in', 'X', 'ig', 'f'];

// ────────────────────────────────────────────────
// 2. Ссылки на соцсети
// ────────────────────────────────────────────────
const SOCIAL_LINKS = {
  'in': 'https://www.linkedin.com/company/110900948  ',
  'X': '#',
  'ig': '#',
  'f': '#',
};

// ────────────────────────────────────────────────
// 3. Стили
// ────────────────────────────────────────────────
// Определение браузера Samsung
const isSamsungBrowser = () =>
  typeof navigator !== 'undefined' && /SamsungBrowser/i.test(navigator.userAgent);

const LIGHT_VARS = {
  bg: 'rgba(240,238,255,0.45)',
  fg: '#1a1a38',
  border: 'rgba(180,170,225,0.38)',
  blur: 'blur(12px)',
  hover: '#7b5eff',
  social: '#8888cc',
  copy: '#555577',
  inputBg: 'rgba(255,255,255,0.8)',
  inputBorder: 'rgba(120,110,180,0.3)',
  inputFg: '#1a1a38',
  buttonBg: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  buttonHover: 'linear-gradient(135deg, #7376f2 0%, #9b6cf7 100%)',
  modalBg: 'rgba(250,249,255,0.92)',
};

const getThemeVars = (theme) => theme === 'dark' ? {
  bg: 'rgba(20,18,42,0.38)',
  fg: '#e8e8ff',
  border: 'rgba(70,60,120,0.3)',
  blur: 'blur(12px)',
  hover: '#b19fff',
  social: '#c0b3ff',
  copy: '#bbbbd0',
  inputBg: 'rgba(15,23,42,0.6)',
  inputBorder: 'rgba(70,60,120,0.4)',
  inputFg: '#e0e0ff',
  buttonBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  buttonHover: 'linear-gradient(135deg, #768eeb 0%, #865bb3 100%)',
  modalBg: 'rgba(10,8,28,0.92)',
} : LIGHT_VARS; // 'light' и 'samsung' — светлая тема

const baseStyles = {
  footer: (vars, isMobile) => ({
    width: '100vw',
    marginLeft: 'calc(-50vw + 50%)',
    marginRight: 'calc(-50vw + 50%)',
    background: vars.bg,
    backdropFilter: vars.blur,
    borderTop: `1px solid ${vars.border}`,
    color: vars.fg,
    padding: `${isMobile ? 16 : 20}px 20px ${isMobile ? `calc(40px + env(safe-area-inset-bottom))` : '20px'}`,
    boxSizing: 'border-box',
  }),
  container: {
    maxWidth: 1400,
    margin: '0 auto',
  },
  partners: (isMobile) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: isMobile ? 48 : 100,
    marginTop: 0,
    paddingTop: isMobile ? 4 : 6,
    paddingBottom: isMobile ? 2 : 4,
    marginBottom: isMobile ? 24 : 36,
    flexWrap: 'wrap',
  }),
  partnerButton: (isHovered, isPressed) => ({
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transform: `scale(${isPressed ? 0.95 : isHovered ? 1.08 : 1})`,
    transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), filter 0.3s ease',
    filter: isHovered ? 'brightness(1.2)' : 'none',
  }),
  partnerImg: (isMobile, theme, isHovered, index = 99) => {
    // Samsung Browser затемняет экран системно, поэтому добавляем brightness(1.8)
    // чтобы белый цвет не выглядел серым после инверсии
    const samsungFilter = `brightness(0) invert(1) brightness(1.8)${isHovered ? ' drop-shadow(0 0 8px rgba(255,255,255,0.7))' : ''}`;
    const darkFilter = `brightness(0) invert(1)${isHovered ? ' drop-shadow(0 0 8px rgba(255,255,255,0.5))' : ''}`;
    const lightFilter = `grayscale(1) brightness(1.38) contrast(0.82)${isHovered ? ' drop-shadow(0 0 8px rgba(0,0,0,0.3))' : ''}`;
    const lightBlackFilter = `brightness(0)${isHovered ? ' drop-shadow(0 0 8px rgba(0,0,0,0.4))' : ''}`;

    const resolvedFilter =
      theme === 'samsung' ? samsungFilter :
      theme === 'dark'    ? darkFilter    :
      index < 2           ? lightBlackFilter :
                            lightFilter;

    return {
      height: isMobile ? 65 : 85,
      maxWidth: isMobile ? '90px' : '140px',
      width: 'auto',
      objectFit: 'contain',
      filter: resolvedFilter,
      WebkitFilter: resolvedFilter,
      display: 'block',
      transition: 'filter 0.3s ease',
    };
  },
  // Кнопка фидбека — теперь с текстом
  feedbackButton: (vars, isHovered, isPressed, isMobile) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: isMobile ? '8px 14px' : '10px 18px',
    borderRadius: '12px',
    border: `2px solid ${isHovered ? vars.hover : vars.social}`,
    background: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    transform: isPressed ? 'scale(0.93)' : isHovered ? 'scale(1.05)' : 'scale(1)',
    boxShadow: isHovered ? `0 4px 12px ${vars.social}60` : 'none',
  }),
  feedbackIcon: (vars, isHovered, isMobile) => ({
    width: isMobile ? 20 : 22,
    height: isMobile ? 20 : 22,
    filter: isHovered
      ? `brightness(0) saturate(100%) invert(47%) sepia(98%) saturate(400%) hue-rotate(210deg) brightness(105%)`
      : `brightness(0) saturate(100%) invert(60%) sepia(20%) saturate(400%) hue-rotate(210deg) brightness(90%)`,
    transition: 'filter 0.3s ease',
  }),
  feedbackLabel: (vars, isHovered) => ({
    fontSize: '0.95rem',
    fontWeight: '600',
    color: isHovered ? vars.hover : vars.social,
    transition: 'color 0.3s ease',
    whiteSpace: 'nowrap',
  }),
  // Модалка — минималистичная
  modalOverlay: (vars, isMobile) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.45)',
    backdropFilter: 'blur(8px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    padding: isMobile ? '16px' : '24px',
  }),
  modalCard: (vars, isMobile) => ({
    position: 'relative',
    width: isMobile ? '100%' : '520px',
    maxWidth: '100%',
    maxHeight: '90vh',
    background: vars.modalBg,
    backdropFilter: vars.blur,
    borderRadius: '24px',
    border: `1px solid ${vars.border}`,
    padding: isMobile ? '32px 24px' : '48px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    boxShadow: theme => theme === 'dark'
      ? '0 25px 50px rgba(0,0,0,0.5)'
      : '0 25px 50px rgba(0,0,0,0.12)',
  }),
  modalCloseButton: (vars, isHovered) => ({
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    background: 'none',
    border: `1px solid ${isHovered ? vars.hover : vars.border}`,
    color: vars.fg,
    fontSize: '1.4rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    transform: isHovered ? 'scale(1.1) rotate(90deg)' : 'scale(1) rotate(0deg)',
  }),
  modalTitle: (vars, isMobile) => ({
    fontSize: isMobile ? '1.4rem' : '1.8rem',
    fontWeight: '700',
    marginBottom: isMobile ? '8px' : '12px',
    color: vars.fg,
    textAlign: 'center',
  }),
  modalSubtitle: (vars, isMobile) => ({
    fontSize: isMobile ? '0.85rem' : '0.95rem',
    color: vars.copy,
    marginBottom: isMobile ? '24px' : '32px',
    lineHeight: 1.5,
    textAlign: 'center',
  }),
  formGroup: (isMobile) => ({
    marginBottom: isMobile ? '16px' : '24px',
  }),
  formLabel: (vars) => ({
    display: 'block',
    fontSize: '0.9rem',
    fontWeight: '600',
    marginBottom: '8px',
    color: vars.fg,
  }),
  formInput: (vars, isMobile, isFocused) => ({
    width: '100%',
    padding: isMobile ? '12px 16px' : '14px 20px',
    background: vars.inputBg,
    border: `2px solid ${isFocused ? vars.hover : vars.inputBorder}`,
    borderRadius: '14px',
    color: vars.inputFg,
    fontSize: isMobile ? '1rem' : '1.05rem',
    boxSizing: 'border-box',
    transition: 'all 0.3s ease',
    outline: 'none',
    boxShadow: isFocused ? `0 0 0 4px ${vars.hover}20` : 'none',
  }),
  formTextarea: (vars, isMobile, isFocused) => ({
    width: '100%',
    padding: isMobile ? '12px 16px' : '14px 20px',
    background: vars.inputBg,
    border: `2px solid ${isFocused ? vars.hover : vars.inputBorder}`,
    borderRadius: '14px',
    color: vars.inputFg,
    fontSize: isMobile ? '1rem' : '1.05rem',
    minHeight: isMobile ? '100px' : '150px',
    resize: 'vertical',
    boxSizing: 'border-box',
    lineHeight: 1.6,
    transition: 'all 0.3s ease',
    outline: 'none',
    boxShadow: isFocused ? `0 0 0 4px ${vars.hover}20` : 'none',
  }),
  submitButton: (vars, isSubmitting, isMobile, isHovered, isPressed) => ({
    width: '100%',
    padding: isMobile ? '14px 20px' : '16px 32px',
    background: isSubmitting ? 'rgba(99, 102, 241, 0.5)' : vars.buttonBg,
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    fontSize: '1.05rem',
    fontWeight: '600',
    cursor: isSubmitting ? 'not-allowed' : 'pointer',
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    boxShadow: isPressed
      ? '0 2px 8px rgba(0,0,0,0.15)'
      : isHovered && !isSubmitting
        ? '0 6px 20px rgba(99, 102, 241, 0.4)'
        : '0 4px 15px rgba(0,0,0,0.2)',
    transform: isPressed ? 'scale(0.98) translateY(2px)' : isHovered && !isSubmitting ? 'scale(1.02)' : 'scale(1)',
  }),
  socialSection: (vars) => ({
    borderTop: `1px solid ${vars.border}`,
    padding: '20px 0',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  socialIconsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 20,
    flexWrap: 'wrap',
  },
  socialLink: (isMobile, vars, isHovered) => ({
    width: isMobile ? 40 : 48,
    height: isMobile ? 40 : 48,
    borderRadius: '50%',
    border: `2px solid ${isHovered ? vars.hover : vars.social}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    transform: isHovered ? 'scale(1.15) rotate(10deg)' : 'scale(1) rotate(0deg)',
    boxShadow: isHovered ? `0 4px 12px ${vars.social}60` : 'none',
  }),
  socialIcon: (vars, isHovered) => ({
    fontSize: '1.3rem',
    fontWeight: 'bold',
    color: isHovered ? vars.hover : vars.social,
    transition: 'all 0.3s ease',
  }),
  bottomSection: (isMobile, vars) => ({
    paddingTop: 20,
    borderTop: `1px solid ${vars.border}`,
    fontSize: isMobile ? '0.85rem' : '0.95rem',
    color: vars.copy,
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: isMobile ? 20 : 0,
  }),
  legalLinksContainer: (isMobile) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: isMobile ? 16 : 24,
    justifyContent: 'center',
  }),
  legalLink: (vars, isHovered) => ({
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    color: isHovered ? vars.hover : vars.copy,
    transition: 'all 0.3s ease',
    textDecoration: isHovered ? 'underline' : 'none',
  }),
};

// ────────────────────────────────────────────────
// 4. Компонент модального окна фидбека (минималистичный)
// ────────────────────────────────────────────────
const FeedbackModal = ({ isOpen, onClose, lang, theme }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const currentLang = lang === 'fr' ? 'fr' : 'en';
  const vars = getThemeVars(theme);
  const s = baseStyles;
  const texts = FEEDBACK_FORM[currentLang];

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !message) {
      createToast(texts.error, 'error');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_URL}/api/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.trim(),
          message: message.trim(),
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        createToast(texts.success, 'success');
        setEmail('');
        setMessage('');
        setIsSubmitting(false);
        onClose();
      } else {
        createToast(texts.error, 'error');
        console.error('Feedback error:', data);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('Feedback submission error:', error);
      createToast(texts.error, 'error');
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={s.modalOverlay(vars, isMobile)} onClick={onClose}>
      <div
        style={s.modalCard(vars, isMobile)}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          style={s.modalCloseButton(vars)}
          onMouseEnter={(e) => e.target.style.opacity = '1'}
          onMouseLeave={(e) => e.target.style.opacity = '0.7'}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ×
        </button>

        <h2 style={s.modalTitle(vars, isMobile)}>{texts.title}</h2>
        <p style={s.modalSubtitle(vars, isMobile)}>{texts.subtitle}</p>

        <form onSubmit={handleSubmit}>
          <div style={s.formGroup(isMobile)}>
            <label style={s.formLabel(vars)}>{texts.emailLabel}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={texts.emailPlaceholder}
              disabled={isSubmitting}
              onFocus={() => setFocusedField('email')}
              onBlur={() => setFocusedField(null)}
              style={s.formInput(vars, isMobile, focusedField === 'email')}
              required
            />
          </div>

          <div style={s.formGroup(isMobile)}>
            <label style={s.formLabel(vars)}>{texts.messageLabel}</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={texts.messagePlaceholder}
              disabled={isSubmitting}
              onFocus={() => setFocusedField('message')}
              onBlur={() => setFocusedField(null)}
              style={s.formTextarea(vars, isMobile, focusedField === 'message')}
              required
              rows={isMobile ? "4" : "6"}
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting || !email || !message}
            style={s.submitButton(vars, isSubmitting, isMobile)}
          >
            {isSubmitting ? '⏳ Sending...' : texts.submit}
          </button>
        </form>
      </div>
    </div>
  );
};

// ────────────────────────────────────────────────
// 5. Основной компонент футера
// ────────────────────────────────────────────────
export default function Footer({ lang = 'en', theme = 'dark' }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [hoveredPartner, setHoveredPartner] = useState(null);
  const [pressedPartner, setPressedPartner] = useState(null);
  const [feedbackHovered, setFeedbackHovered] = useState(false);
  const [feedbackPressed, setFeedbackPressed] = useState(false);
  const [hoveredSocial, setHoveredSocial] = useState(null);
  const [hoveredLegal, setHoveredLegal] = useState(null);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setIsFeedbackOpen(false);
      }
    };
    if (isFeedbackOpen) {
      window.addEventListener('keydown', handleEsc);
      return () => window.removeEventListener('keydown', handleEsc);
    }
  }, [isFeedbackOpen]);

  const currentLang = lang === 'fr' ? 'fr' : 'en';
  const activeTheme = isSamsungBrowser() ? 'samsung' : theme;
  const vars = getThemeVars(activeTheme);
  const s = baseStyles;
  const texts = FEEDBACK_FORM[currentLang];

  return (
    <>
      <footer style={s.footer(vars, isMobile)}>
        <div style={s.container}>
          {/* Партнёры */}
          <div style={s.partners(isMobile)}>
            {PARTNERS[currentLang].map((partner, i) => (
              <button
                key={i}
                onClick={() => window.open(partner.url, '_blank', 'noopener,noreferrer')}
                onMouseEnter={() => setHoveredPartner(i)}
                onMouseLeave={() => {
                  setHoveredPartner(null);
                  setPressedPartner(null);
                }}
                onMouseDown={() => setPressedPartner(i)}
                onMouseUp={() => setPressedPartner(null)}
                style={s.partnerButton(hoveredPartner === i, pressedPartner === i)}
                title={partner.name}
              >
                {partner.svgComponent === 'google' ? (
                  <div style={{
                    height: isMobile ? 40 : 52,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: '4px',
                    filter: activeTheme === 'dark' ? 'brightness(0) invert(1)' : 'none',
                    WebkitFilter: activeTheme === 'dark' ? 'brightness(0) invert(1)' : 'none',
                    transition: 'filter 0.3s ease',
                  }}>
                    <GoogleLogo height={isMobile ? 32 : 44} />
                  </div>
                ) : partner.svgComponent === 'linkedin' ? (
                  <div style={{
                    height: isMobile ? 48 : 60,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <LinkedInLogo height={isMobile ? 42 : 54} theme={activeTheme} />
                  </div>
                ) : activeTheme === 'samsung' ? (
                  // brightness(100) вытягивает все пиксели в белый —
                  // Samsung поддерживает brightness() в отличие от invert()
                  <img
                    src={partner.image}
                    alt={partner.name}
                    style={{
                      height: isMobile ? 65 : 85,
                      maxWidth: isMobile ? '90px' : '140px',
                      width: 'auto',
                      objectFit: 'contain',
                      display: 'block',
                      filter: hoveredPartner === i
                        ? 'brightness(100) drop-shadow(0 0 8px rgba(255,255,255,0.6))'
                        : 'brightness(100)',
                      WebkitFilter: hoveredPartner === i
                        ? 'brightness(100) drop-shadow(0 0 8px rgba(255,255,255,0.6))'
                        : 'brightness(100)',
                      transition: 'filter 0.3s ease, opacity 0.3s ease',
                      opacity: hoveredPartner === i ? 0.85 : 1,
                    }}
                  />
                ) : (
                  <img
                    src={partner.image}
                    alt={partner.name}
                    style={s.partnerImg(isMobile, activeTheme, hoveredPartner === i, i)}
                  />
                )}
              </button>
            ))}
          </div>

          {/* Соцсети + Feedback */}
          <div style={s.socialSection(vars)}>
            <div style={s.socialIconsContainer}>
              {SOCIAL_ICONS.map((icon, i) => (
                <a
                  key={i}
                  href={SOCIAL_LINKS[icon]}
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseEnter={() => setHoveredSocial(i)}
                  onMouseLeave={() => setHoveredSocial(null)}
                  style={s.socialLink(isMobile, vars, hoveredSocial === i)}
                >
                  <span style={s.socialIcon(vars, hoveredSocial === i)}>{icon}</span>
                </a>
              ))}
            </div>
            <button
              onClick={() => setIsFeedbackOpen(true)}
              onMouseEnter={() => setFeedbackHovered(true)}
              onMouseLeave={() => {
                setFeedbackHovered(false);
                setFeedbackPressed(false);
              }}
              onMouseDown={() => setFeedbackPressed(true)}
              onMouseUp={() => setFeedbackPressed(false)}
              style={s.feedbackButton(vars, feedbackHovered, feedbackPressed, isMobile)}
              title={texts.button}
            >
              <img
                src={FeedbackIcon}
                alt={texts.button}
                style={s.feedbackIcon(vars, feedbackHovered, isMobile)}
              />
              <span style={s.feedbackLabel(vars, feedbackHovered)}>{texts.button}</span>
            </button>
          </div>

          {/* Нижняя часть */}
          <div style={s.bottomSection(isMobile, vars)}>
            <div>{COPYRIGHT[currentLang]}</div>
            <div style={s.legalLinksContainer(isMobile)}>
              {LEGAL_LINKS[currentLang].map((link, i) => (
                <span
                  key={i}
                  onClick={() => navigate(link.path)}
                  onMouseEnter={() => setHoveredLegal(i)}
                  onMouseLeave={() => setHoveredLegal(null)}
                  style={s.legalLink(vars, hoveredLegal === i)}
                >
                  {link.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </footer>

      {/* Модальное окно фидбека */}
      <FeedbackModal
        isOpen={isFeedbackOpen}
        onClose={() => setIsFeedbackOpen(false)}
        lang={lang}
        theme={activeTheme}
      />
    </>
  );
}